import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import CommittedExpendituresCreateList from './CommittedExpendituresCreateList';

export default function CommittedExpendituresCreate() {
    return (
        <>
            <h5 className="text-blue font-weight-600 mb-2">
                {'Department: ' + department.name} {costcenter !== undefined ?? ' - Cost Center: ' + costcenter.name}
            </h5>
            <CommittedExpendituresCreateList
                committedExpendituresIndexUrl={committedExpendituresIndexUrl}
                committedExpendituresCreateUrl={committedExpendituresCreateUrl}
                committedExpendituresStoreUrl={committedExpendituresStoreUrl}
                uncommittedExpendituresCreateUrl={uncommittedExpendituresCreateUrl}
                uncommittedExpendituresDetailsUrl={uncommittedExpendituresDetailsUrl}
                uncommittedExpendituresUpdateUrl={uncommittedExpendituresUpdateUrl}
                uncommittedExpendituresPreCommitUrl={uncommittedExpendituresPreCommitUrl}
                expenseFundApprovalsUpdateUrl={expenseFundApprovalsUpdateUrl}
                suppliersIndexUrl={suppliersIndexUrl}
                uncommittedExpenditureGroupId={uncommittedExpenditureGroupId}
                uncommittedExpenditureId={uncommittedExpenditureId}
                department={department}
                costcenter={costcenter}
            />
        </>
    );
}

if (document.getElementById('CommittedExpendituresCreate')) {
    var rootEl = document.getElementById('CommittedExpendituresCreate');
    ReactDOM.render(
        <App>
            <CommittedExpendituresCreate />
        </App>,
        rootEl,
    );
}
